import React from 'react';
import CustomTable from '../../components/CustomTable';
import {globales, colores, funciones} from '../../global';
import AuthService            from '../../AuthService';
import Request from 'superagent';
import Paper from '@material-ui/core/Paper';
import {withStyles} from '@material-ui/core/styles';
import BarraBotones   from '../../components/Barra_menu';
import {Table} from '@devexpress/dx-react-grid-material-ui';
import {IntegratedFiltering} from '@devexpress/dx-react-grid';
import SwipeableViews from 'react-swipeable-views';
import Backdrop from '@material-ui/core/Backdrop';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DialogActions from '@material-ui/core/DialogActions';
import Select from '../../components/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter'; import CheckIcon from '@material-ui/icons/Check';

let Auth = new AuthService();
let tokenInfo = [];

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let currentRef;
const settingFilter = [

  { columnName: 'OBLIGATORIA',
     predicate: (value, filter, row) => {
                filter.value = filter.value.trim().length === 1 ? filter.value.trim().replace('1', 'Si').replace('0', 'No') : filter.value;
                value = (value === true) ? 'Si' : 'No';
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'BECADOS',
     predicate: (value, filter, row) => {
                filter.value = filter.value.trim().length === 1 ? filter.value.trim().replace('1', 'Si').replace('0', 'No') : filter.value;
                value = (value === true) ? 'Si' : 'No';
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'PRIMER_INGRESO',
     predicate: (value, filter, row) => {
                filter.value = filter.value.trim().length === 1 ? filter.value.trim().replace('1', 'Si').replace('0', 'No') : filter.value;
                value = (value === true) ? 'Si' : 'No';
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'FINANCIADO',
     predicate: (value, filter, row) => {
                filter.value = filter.value.trim().length === 1 ? filter.value.trim().replace('1', 'Si').replace('0', 'No') : filter.value;
                value = (value === true) ? 'Si' : 'No';
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'PUBLICAR',
     predicate: (value, filter, row) => {
                filter.value = filter.value.trim().length === 1 ? filter.value.trim().replace('1', 'Si').replace('0', 'No') : filter.value;
                value = (value === true) ? 'Si' : 'No';
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'TRAMITE_UNICO',
     predicate: (value, filter, row) => {
                filter.value = filter.value.trim().length === 1 ? filter.value.trim().replace('1', 'Si').replace('0', 'No') : filter.value;
                value = (value === true) ? 'Si' : 'No';
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'ESTATUS',
     predicate: (value, filter, row) => {
                filter.operation = 'startsWith'; 
                filter.value = filter.value.trim().length === 1 ? filter.value.trim().replace('1', 'Activa').replace('0', 'Inactiva') : filter.value;
                value = (value === true) ? 'Activa' : 'Inactiva';
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'MONTO',
     predicate: (value, filter, row) => {
                value = row.MONEDA + ' ' + funciones.formatCurrency(value); 
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },

];
const datosSelectOpciones = [{ value: 0, label: 'No' },
                             { value: 1, label: 'Si' }];

const datosSelectEstado = [{ value: 0, label: 'Inactiva' },
                           { value: 1, label: 'Activa' }];
let datosSelectTipoTransacciones = [];
let datosSelectSucursales = [];
let datosSelectMonedas = [];

const styles = theme => ({

closeButton: {
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
},
tab:{
  textTransform: 'none',
  minWidth: !movil ? '110px' : "25%",
  fontSize: '8px'
},
textField: {
  maxWidth: '100%',
  marginTop: theme.spacing(2), 
},
formControlSelect: {
  width: '100%', 
  marginTop: theme.spacing(2),  
  textAlign: 'left',
},
formControl: {
  width: '100%',   
  textAlign: 'left',
},
backdrop: {
  zIndex: 500000,
  color: '#fff', 
  flexDirection: 'column'
},
paper: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '442px' : undefined, 
  maxWidth: !movil ? '442px' : undefined,
  height: !movil ? '570px' : undefined, 
  maxHeight: !movil ? '99%' : undefined
},
paperConfirm: { 
  borderRadius: globales.border_dialog,
  minWidth: '320px', 
  maxWidth: '320px', 
},
theme: { direction: theme.direction },
});
const widthTable = !movil ? window.screen.width - (globales.tabla.marginleft + globales.tabla.marginright) : 1336;
const columns =  [  
    { name: 'ID_GESTION', title: 'ID_GESTION' },
    { name: 'CODIGO_TRANSACCION', title: 'Código'  },
    { name: 'DESCRIPCION', title: 'Descripción' },
    { name: 'DESCRIPCION_TRANSACCION', title: 'Tipo transacción'},
    { name: 'OBLIGATORIA', title: 'Obligatoria' },
    { name: 'BECADOS', title: 'Becados' },                  
    { name: 'PRIMER_INGRESO', title: 'Primer ing.'},
    { name: 'FINANCIADO', title: 'Financiado'},
    { name: 'PUBLICAR', title: 'Publicar'},
    { name: 'TRAMITE_UNICO', title: 'Única'},
    { name: 'MONEDA', title: 'Moneda'},
    { name: 'DESCRIPCION_SUCURSAL', title: 'Sucursal'},
    { name: 'CUENTA_CONTABLE', title: 'Cuenta contable'},
    { name: 'MONTO', title: 'Monto'},
    { name: 'ESTATUS', title: 'Estado'},
];
const columnExtensions = [ 
  { columnName: 'CODIGO_TRANSACCION', width: widthTable * 0.08},
  { columnName: 'DESCRIPCION', width: widthTable * 0.22 },
  { columnName: 'OBLIGATORIA',  width: widthTable * 0.07, align: 'center'}, 
  { columnName: 'BECADOS', width: widthTable * 0.07, align: 'center'},
  { columnName: 'PRIMER_INGRESO', width: widthTable * 0.07, align: 'center'},
  { columnName: 'FINANCIADO', width: widthTable * 0.07,  align: 'center'},
  { columnName: 'PUBLICAR', width: widthTable * 0.07, align: 'center'},
  { columnName: 'TRAMITE_UNICO', width: widthTable * 0.07, align: 'center'},
  { columnName: 'MONTO', width: widthTable * 0.08, align: 'center'},
  { columnName: 'ESTATUS', width: widthTable * 0.08, align: 'center'},
  { columnName: 'ID_GESTION', width: 0},
  { columnName: 'CUENTA_CONTABLE', width: 0},
  { columnName: 'DESCRIPCION_SUCURSAL', width: 0},   
  { columnName: 'MONEDA', width: 0},         
  { columnName: 'DESCRIPCION_SUCURSAL', width: 0},  
  { columnName: 'DESCRIPCION_TRANSACCION', width: 0},
];
const grouping = [{columnName: 'DESCRIPCION_SUCURSAL'}, {columnName: 'DESCRIPCION_TRANSACCION'}];

const RowId = row => row.ID_GESTION;
const GroupCellContent = ({ column, row }) => {
  return (<span>    
           <strong>{row.value === null ? 'Generales' : row.value}</ strong>
          </span>
          );
}
const VirtualTable_cellComponent = (props) => {  
  
  const _style = {color: !props.row.ESTATUS ? colores.color_inactive : undefined, padding: 0} 

  if (props.column.name === 'OBLIGATORIA')
  {
    return (<Table.Cell style={_style} {...props}>
             {Boolean(props.row.OBLIGATORIA) ? <CheckIcon /> : <br />}
            </Table.Cell>);
  }
  
  if (props.column.name === 'BECADOS')
  {
    return (<Table.Cell style={_style} {...props}>
           {Boolean(props.row.BECADOS) ? <CheckIcon /> : <br />}
           </Table.Cell>);
  }

  if (props.column.name === 'PRIMER_INGRESO')
  {
    return (<Table.Cell style={_style} {...props}>
            {Boolean(props.row.PRIMER_INGRESO) ? <CheckIcon /> : <br />}
            </Table.Cell>);
  }
  
  if (props.column.name === 'FINANCIADO')
  {
    return (<Table.Cell style={_style} {...props}>
            {Boolean(props.row.FINANCIADO) ? <CheckIcon /> : <br />}
           </Table.Cell>
      );
  }
  
  if (props.column.name === 'PUBLICAR')
  {
    return (<Table.Cell style={_style} {...props}>
            {Boolean(props.row.PUBLICAR) ? <CheckIcon /> : <br />}
           </Table.Cell>
           );
  }
  
  if (props.column.name === 'TRAMITE_UNICO')
  {
    return (<Table.Cell style={_style} {...props}>
            {Boolean(props.row.TRAMITE_UNICO) ? <CheckIcon /> : <br />}
            </Table.Cell>
           );
  }
  
  if (props.column.name === 'MONTO')
  { 
    return (<Table.Cell style={_style} {...props}>
             {props.row.MONEDA + ' ' + funciones.formatCurrency(props.row.MONTO)}            
            </ Table.Cell>);
  }
  
  if (props.column.name === 'ESTATUS')
  {
      return (<Table.Cell style={_style} {...props}>
               {props.row.ESTATUS ? 'Activa' : 'Inactiva'}
              </Table.Cell>);
  }
    
  return (<Table.Cell style={_style} {...props}/>);
    
}
const TabPanel = (props) =>{
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2} pt={3}>
          {children}
        </Box>
      )}
    </div>
  );
}
const TabLabel = (label)=>{

  return (<Typography component={'span'} variant={'body2'}>{label}</Typography>);

}
const StubCellComponentTable = ({ colSpan,...props}) => {
    
  if (props.tableRow.type.toString() === 'Symbol(data)' && props.tableColumn.type.toString() === "Symbol(group)" && props.tableRow.row.CUENTA_CONTABLE !== null && props.tableRow.row.CUENTA_CONTABLE.trim().length > 0 && props.tableColumn.column.name === 'DESCRIPCION_SUCURSAL')
  {  
    
    return (<Table.StubCell colSpan={props.tableColumn.key === "Symbol(flex)" ? 2 : colSpan} style={{ textAlign: 'center' }} {...props}>
            <Tooltip title={'Cuenta contable: ' + props.tableRow.row.CUENTA_CONTABLE}>
               <BusinessCenterIcon style={{ color: colores.color_disabled, cursor: 'default' }}/>
            </Tooltip>
          </ Table.StubCell>
          );
  }
 
 return (<Table.StubCell colSpan={props.tableColumn.key === "Symbol(flex)" ? 2 : colSpan} {...props}/>);

}

export default withStyles(styles) (
class App extends React.Component {

tablaRef = React.createRef();
paperRef = React.createRef();
vtRef = React.createRef();
codigoRef = React.createRef();
descripcionRef = React.createRef();
ttRef = React.createRef();
obligatoriaRef = React.createRef();
sucursalRef = React.createRef();
estadoRef = React.createRef();
montoRef = React.createRef();
monedaRef = React.createRef();
ccRef = React.createRef();
piRef = React.createRef();

  constructor (props) {
    super(props);
    this.l=props.l
    this.e=props.e
    this.i=props.i
    this.state = {
       isLoggin : undefined,
       heightTableMain: 0,
       rows: [],
       isLoadingMain: true,
       expandedGroups: [],
       idRowSelected: null,
       openModal: false,
       openModalConfirm: false,
       actionModal: 0,
       valueTab: 0,
       datosSelectOpciones: datosSelectOpciones.map((item, i) => { return <MenuItem value={item.value} key={i} >{item.label}</MenuItem> }), 
       datosSelectEstado: datosSelectEstado.map((item, i) => { return <MenuItem value={item.value} key={i} >{item.label}</MenuItem> }), 
       selectedTT: '',
       selectedObligatoria: '',
       selectedSucursal: '',
       selectedEstado: '',
       selectedPI: '',
       selectedMoneda: '',
       selectedFinanciado: '',
       selectedTU: '',
       selectedBecados: '', 
       selectedPublicar: '',
       openBackDrop: false,
    };
    this.codigo = null;
    this.descripcion = null;
    this.monto = null;
    this.cc= null;
    this.DESCRIPCION_SUCURSAL = null;
    this.DESCRIPCION_TRANSACCION = null;
    this.botones = [
      {icono: 'Add', toolt: 'Agregar gestión',    nombre: 'Agregar'   ,escritura:true, onclick: this.addEvent,  display: 'auto'},
      {icono: 'Edit', toolt: 'Modificar gestión', nombre: 'Modificar' ,escritura:true, onclick: this.editEvent,  display:'auto'},
      {icono: 'Delete', toolt: 'Eliminar gestión', nombre: 'Eliminar' ,escritura:true, onclick: this.deleteEvent, color: colores.naranja, display: 'auto'}, 
    ];
    this.botones_agregar =[
      {icono: 'Save', toolt: '', nombre: 'Guardar', onclick: this.handleOK, display:'auto'},
      {icono: 'Close', toolt: '', nombre: 'Cerrar' , onclick: this.handleClose, display:'auto', color: 'red'},
    ];
    this.botones_eliminar =[
      {icono: 'Check', toolt: '', nombre: 'Aceptar', onclick: this.handleOK, display:'auto'},
      {icono: 'Close', toolt: '', nombre: 'Cerrar' ,onclick: this.handleCloseConfirm, display:'auto', color: 'red'},
    ];
}

changeExpandedGroups = expandedGroups =>
{
  this.setState({ expandedGroups });      
}

handleRowClick = (idRow) => event => {      
  this.setState({ idRowSelected: idRow });
}

handleClose = ()=>{
  this.setState({ openModal: false });
}

handleCloseConfirm = ()=>{
  this.setState({ openModalConfirm: false });
}

addEvent = ()=>{

  this.codigo = null;
  this.descripcion = null;
  this.monto = null;
  this.cc= null;
  this.DESCRIPCION_SUCURSAL = null;
  this.DESCRIPCION_TRANSACCION = null;
  this.setState({ valueTab: 0,
                  selectedTT: '',
                  selectedObligatoria: 0,
                  selectedSucursal: -1,
                  selectedEstado: 1,
                  selectedPI: 0,
                  selectedMoneda: '',
                  selectedFinanciado: 0,
                  selectedTU: 0,
                  selectedBecados: 1, 
                  selectedPublicar: 0,
                  actionModal: 1,                  
                  openModal: true });

}

editEvent = ()=>{

if (this.state.idRowSelected === null)
 return;


let infoRow = this.state.rows.find(x => x.ID_GESTION === this.state.idRowSelected);

this.codigo = infoRow.CODIGO_TRANSACCION;
this.descripcion = infoRow.DESCRIPCION;
this.monto = parseFloat(infoRow.MONTO).toFixed(2).toString();
this.cc = infoRow.CUENTA_CONTABLE;
this.DESCRIPCION_SUCURSAL = infoRow.DESCRIPCION_SUCURSAL;
this.DESCRIPCION_TRANSACCION = infoRow.DESCRIPCION_TRANSACCION; 

this.setState({ selectedTT: infoRow.ID_TIPO_TRANSACCION,
                selectedObligatoria: infoRow.OBLIGATORIA ? 1 : 0,
                selectedSucursal: infoRow.ID_SUCURSAL === null ? -1 : infoRow.ID_SUCURSAL,
                selectedEstado: infoRow.ESTATUS ? 1 : 0,
                selectedMoneda: infoRow.ID_MONEDA === null ? '' : infoRow.ID_MONEDA,
                selectedFinanciado: infoRow.FINANCIADO ? 1 : 0,
                selectedTU: infoRow.TRAMITE_UNICO ? 1 : 0,
                selectedPI: infoRow.PRIMER_INGRESO ? 1 : 0,
                selectedBecados: infoRow.BECADOS ? 1 : 0,
                selectedPublicar: infoRow.PUBLICAR ? 1 : 0,
                valueTab: 0,
                actionModal: 2,
                openModal: true});

}

deleteEvent = ()=>{

if (this.state.idRowSelected === null)
  return;

this.setState({ actionModal: 3,
                openModalConfirm: true});

}

onEntering = ()=>{
  if (!movil)
  this.codigoRef.current.focus();
}

handleChangeTab = (event, newValue)=>{ 
  this.setValuesTab(this.state.valueTab);
  this.setState({ valueTab: newValue });
}

handleChangeIndexTab = (index)=>{
  this.setValuesTab(this.state.valueTab);
  this.setState({ valueTab: index });
}

setValuesTab = (index)=>{

  switch (index){
    case 0: 
      this.codigo = this.codigoRef.current.value;
      this.descripcion = this.descripcionRef.current.value;
      break;
    case 1:
      this.monto = this.montoRef.current.value;
      break;
    case 3:
      this.cc = this.ccRef.current.value;
      break;
    default:
      break;

  }

}

onTransitionEnd = () => {
  
  if (movil){
    currentRef = undefined;
    return;
  }

  if (currentRef !== undefined && currentRef.current !== null) 
  {
    currentRef.current.focus();
    currentRef = undefined;
    return;
  }

  switch (this.state.valueTab) { 
     case 0:
        this.codigoRef.current.focus();
        break;
     case 1:        
       this.monedaRef.current.focus();
       break;
     case 2: 
       this.piRef.current.focus();
       break;
     case 3: 
        this.ccRef.current.focus();
        break;
     default:
        break;
  }
 
  currentRef = undefined;

}

handleChangeSelect= (event)=>{ 
  const {value, name} = event.target;
  this.setState({ ["selected" + name]: value });
}

obtener_tipo_transacciones = ()=>{

new Request
.get(`${globales.ip}/gestiones/tipos`)
.set({'authorization': 'Bearer ' + Auth.getToken() })
.retry(1)
.timeout({ response: 15000, deadline: 30000, }) 
.end((err, res) => {
        
   if (err) { 

      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
            
        window.location.reload();
        return;
              
      }

      funciones.showToast('e', 'No hay conexión');
        
      return;
   }
      
   const rows = JSON.parse(res.text);

   if (rows.length > 0) 
   {    
    
     datosSelectTipoTransacciones = rows;
     let items = datosSelectTipoTransacciones.map((datos, i) =>{
      return <MenuItem value={datos.ID_TIPO_TRANSACCION} key={i} >{datos.DESCRIPCION}</MenuItem> 
    });

    this.setState({ datosSelectTT: items });

   }       
   

});

}

obtener_sucursales = ()=>{

  new Request
  .get(`${globales.ip}/gestiones/sucursales`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
     if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
              
          window.location.reload();
          return;
                
        }
  
        funciones.showToast('e', 'No hay conexión');
          
        return;
     }
        
     const rows = JSON.parse(res.text);
  
     if (rows.length > 0) 
     {    
      
       datosSelectSucursales = rows;
       let items = datosSelectSucursales.map((datos, i) =>{
        return <MenuItem value={datos.ID_SUCURSAL} key={i} >{datos.DESCRIPCION_SUCURSAL}</MenuItem> 
      });
  
      this.setState({ datosSelectSucursal: items });
  
     }        
  
});


}

obtener_monedas = ()=>{

  new Request
  .get(`${globales.ip}/gestiones/monedas`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
     if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
              
          window.location.reload();
          return;
                
        }
  
        funciones.showToast('e', 'No hay conexión');
          
        return;
     }
        
     const rows = JSON.parse(res.text);
  
     if (rows.length > 0) 
     {    
      
       datosSelectMonedas = rows;
       let items = datosSelectMonedas.map((datos, i) =>{
        return <MenuItem value={datos.ID_MONEDA} key={i} >{datos.DESCRIPCION}</MenuItem> 
      });
  
      this.setState({ datosSelectMonedas: items });
  
     }        
  
});

}

onBlurMonto = ()=>{
 
 if(this.montoRef.current.value.trim().length > 0)
 this.montoRef.current.value = parseFloat(this.montoRef.current.value).toFixed(2).toString();

}

handleOK = ()=>{

if (this.state.actionModal === 1 || this.state.actionModal === 2)
{
  this.setValuesTab(this.state.valueTab);

  if (funciones.isEmpty(this.codigo))
  {   
      funciones.showToast('w', 'Ingrese el código');
      if (this.state.valueTab !== 0)
      {
         this.setState({ valueTab: 0 });
         return;
      }
              
      this.codigoRef.current.focus();
      return;
  }

  if (funciones.isEmpty(this.descripcion))
  {
      funciones.showToast('w', 'Ingrese la descripción');
      if (this.state.valueTab !== 0)
      { 
        this.setState({ valueTab: 0 }, ()=>{ currentRef = this.descripcionRef; });        
        return;
      }
              
      this.descripcionRef.current.focus();
      return;
  }

  if (funciones.isEmpty(this.state.selectedTT))
  {
    funciones.showToast('w', 'Seleccione el tipo de transacción');
    if (this.state.valueTab !== 0)
    { 
      this.setState({ valueTab: 0 }, ()=>{ currentRef = this.ttRef; });        
      return;
    }

    this.ttRef.current.focus();
    return;
  }

  if (funciones.isEmpty(this.state.selectedMoneda))
  {
    funciones.showToast('w', 'Seleccione la moneda');
    if (this.state.valueTab !== 1)
    { 
      this.setState({ valueTab: 1 }, ()=>{ currentRef = this.monedaRef; });        
      return;
    }

    this.monedaRef.current.focus();
    return;
  }

  if (funciones.isEmpty(this.monto) || isNaN(this.monto)) 
  {
      funciones.showToast('w', 'Ingrese un valor válido para el monto');
      if (this.state.valueTab !== 1)
      { 
        this.setState({ valueTab: 1 }, ()=>{ currentRef = this.montoRef; });        
        return;
      }
              
      this.montoRef.current.focus();
      return;
  }


}

let idGestion = this.state.actionModal === 1 ? 0 : this.state.idRowSelected;
let codigo = this.state.actionModal === 3 ? '-' : this.codigo.trim();
let descripcion = this.state.actionModal === 3 ? '-' : this.descripcion.trim();
let monto = this.state.actionModal === 3 ? 0.00 : parseFloat(this.monto).toFixed(2);
let cc = this.state.actionModal === 3 ? '-' : (this.cc === null || this.cc.trim().length === 0) ? 'NULL' : this.cc.trim();
let idSucursal = this.state.actionModal === 3 ? 0 : this.state.selectedSucursal;
let idTipoTransaccion = this.state.actionModal === 3 ? 0 : this.state.selectedTT;
let idMoneda = this.state.actionModal === 3 ? 0 : this.state.selectedMoneda;
let estatus = this.state.actionModal === 3 ? -1 : this.state.selectedEstado;
let obligatoria = this.state.actionModal === 3 ? -1 : this.state.selectedObligatoria;
let becados = this.state.actionModal === 3 ? -1 : this.state.selectedBecados;
let primerIngreso = this.state.actionModal === 3 ? -1 : this.state.selectedPI;
let financiado = this.state.actionModal === 3 ? -1 : this.state.selectedFinanciado;
let publicar = this.state.actionModal === 3 ? -1 : this.state.selectedPublicar;
let tramiteUnico = this.state.actionModal === 3 ? -1 : this.state.selectedTU;

this.setState({ openBackDrop: true, openModalConfirm: false }, ()=>{

  new Request
      .post(`${globales.ip}/gestiones/operaciones`)
      .set({'authorization': 'Bearer ' + Auth.getToken() })
      .set('Content-Type', 'application/json')
      .send({ id_proceso: this.state.actionModal, 
              id_gestion: idGestion,
              codigo: codigo, 
              descripcion: descripcion,
              monto: monto,
              cuenta_contable: cc,
              id_sucursal: idSucursal,
              id_tipo_transaccion: idTipoTransaccion,
              id_moneda: idMoneda,
              estatus: estatus,
              obligatoria: obligatoria,
              becados: becados,
              primer_ingreso: primerIngreso,
              financiado: financiado,
              publicar: publicar,
              tramite_unico: tramiteUnico,
              ad_usuario: tokenInfo.user })
      .retry(0)
      .timeout({ response: 30000, deadline: 30000, }) 
      .end((err, res) => {
                 
         if (err) { 
          
          if (err.toString().substr(0,16) === 'Error: Forbidden')
          {
             window.location.reload();
             return;                        
          }
          
          this.setState({ openBackDrop: false }, ()=>{ 
            funciones.showToast('e', 'No hay conexión'); 
          });
                    
          return;
         }
                
         const rows = JSON.parse(res.text);
          
         if (rows.length > 0)
         {    
            if (rows[0].RESP === 'OK')
            {       
                    
              let row = this.state.actionModal === 3 ? [{ ID_GESTION: rows[0].ID_GESTION}] :
                        [{ ID_GESTION: rows[0].ID_GESTION,
                           CODIGO_TRANSACCION: codigo,
                           DESCRIPCION: descripcion,
                           ID_TIPO_TRANSACCION: idTipoTransaccion,
                           DESCRIPCION_TRANSACCION: datosSelectTipoTransacciones.find(x => x.ID_TIPO_TRANSACCION === idTipoTransaccion).DESCRIPCION, 
                           OBLIGATORIA: obligatoria === 1 ? true : false,
                           BECADOS: becados === 1 ? true : false,
                           PRIMER_INGRESO: primerIngreso === 1 ? true : false,
                           FINANCIADO: financiado === 1 ? true : false,
                           PUBLICAR: publicar === 1 ? true : false,
                           TRAMITE_UNICO: tramiteUnico === 1 ? true : false,
                           ID_MONEDA: idMoneda,
                           MONEDA: datosSelectMonedas.find(x => x.ID_MONEDA === idMoneda).SIMBOLO,
                           MONTO: parseFloat(monto),
                           CUENTA_CONTABLE: cc === 'NULL' ? null : cc,
                           ID_SUCURSAL: idSucursal === -1 ? null : idSucursal,
                           DESCRIPCION_SUCURSAL: idSucursal === -1 ? null : datosSelectSucursales.find(x => x.ID_SUCURSAL === idSucursal).DESCRIPCION_SUCURSAL, 
                           ESTATUS: estatus === 1 ? true : false
                          }];
              const newStructure = funciones.refreshTable(this.state.actionModal, 
                                                          this.state.rows, 
                                                          this.state.expandedGroups, 
                                                           row, 
                                                           'ID_GESTION',
                                                           'DESCRIPCION_SUCURSAL', 
                                                            this.DESCRIPCION_SUCURSAL,
                                                           'DESCRIPCION_TRANSACCION',
                                                            this.DESCRIPCION_TRANSACCION); 
                                          
              this.setState({ expandedGroups: newStructure.refreshGroups, 
                              rows: newStructure.refreshRows,
                              idRowSelected: this.state.actionModal === 3 ? null : rows[0].ID_GESTION,
                              openBackDrop: false }, ()=>{
                                     
                              if (this.state.actionModal === 3)
                              {
                                return funciones.showToast('s', 'Se ha eliminado la gestión');
                              }
                              
                              if (movil && newStructure.moveScroll) { window.scrollTo(0, this.state.heightTableMain); }
                              if (newStructure.moveScroll){ this.vtRef.current.scrollToRow(rows[0].ID_GESTION); }
                              
                              funciones.showToast('s', this.state.actionModal === 1 ? 'Se ha registrado la gestión' : 'Se han regitrado los cambios');
                              this.handleClose();
                           });

          }
          else
          {
              this.setState({ openBackDrop: false }, ()=>{
                funciones.showToast('w', rows[0].RESP);
              });   
          }
      }
                                    
  });

});


}

changeFilters = filters => { 
 if (this.state.idRowSelected !== null)
  this.setState({ idRowSelected: null });
}

obtener_gestiones = ()=>{

new Request
 .get(`${globales.ip}/gestiones`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .retry(1)
 .timeout({ response: 15000, deadline: 30000, }) 
 .end((err, res) => {
          
   if (err) { 
  
     if (err.toString().substr(0,16) === 'Error: Forbidden')
     {
              
      window.location.reload();
      return;
                
    }
  
    this.setState({ isLoadingMain: false }, ()=>{ 
      funciones.showToast('e', 'No hay conexión');
    });
    
    return;
   }
        
   const rows = JSON.parse(res.text);
      
   this.setState({ rows: rows, isLoadingMain: false });              
             
     
}); 

}

componentDidMount() { 

tokenInfo = Auth.getProfile(); //Token decodificado  
    
this.setState({ isLoggin: tokenInfo.plataforma !== undefined ? true : false }, ()=>{

  if (tokenInfo.plataforma === 1) // Usuario Admin
  {
    this.obtener_gestiones();     
  }
  
  this.setState({ heightTableMain: funciones.getHeightTableMain(movil, this).heightTable });
  this.obtener_tipo_transacciones(); 
  this.obtener_sucursales();
  this.obtener_monedas();

});
               
}

render() {

const { classes } = this.props;

  if (this.state.isLoggin === true)
  {
  return (
    
    <React.Fragment>
      <Paper className="Paper-main" square>
          {
            (() => {
              
            if (tokenInfo.plataforma === 1) //Si es Usuario Admin
             {
              
              return (
                <React.Fragment>
                <BarraBotones align='center' botones={this.botones} l={this.l} e={this.e} i={this.i}/>
                <div ref={this.tablaRef} style={{ marginLeft: !movil ? globales.tabla.marginleft : globales.tabla.marginleft_movil, marginRight: !movil ? globales.tabla.marginright : globales.tabla.marginright_movil }} className="disableTouchOptions">
                <CustomTable 
                    Columns={columns} 
                    Rows={this.state.rows}
                    Grouping={grouping} 
                    TableColumnExtensions={columnExtensions} 
                    columnWidths={columnExtensions}
                    DefaultHiddenColumnNames={['ID_GESTION', 'CUENTA_CONTABLE', 'DESCRIPCION_SUCURSAL', 'MONEDA']}  
                    ExpandedGroups = {this.state.expandedGroups}
                    ChangeExpandedGroups={this.changeExpandedGroups}
                    getRowId={RowId}
                    VirtualTable_cellComponent={VirtualTable_cellComponent}
                    height={this.state.heightTableMain} 
                    loading={this.state.isLoadingMain}
                    rowSelected={this.state.idRowSelected}
                    rowClick={this.handleRowClick}
                    FilteringColumnExtensions={settingFilter}
                    enabledFilterRows
                    groupContentComponent={GroupCellContent}
                    onFiltersChange={this.changeFilters}  
                    stubCellComponentTable={StubCellComponentTable}             
                    vtRef={this.vtRef}
                  />
                  </div>  
                  <Dialog open= {this.state.openModal}                            
                          TransitionProps={{ onEntering: this.onEntering }}
                          classes = {{ paper: classes.paper }}
                          fullScreen = {movil}>
                   <DialogTitle><Typography component='span' variant='subtitle2'>Gestión</Typography>
                    <IconButton className={classes.closeButton} onClick={this.handleClose} size="small">
                     <CloseIcon fontSize="small" />
                    </IconButton>
                   </DialogTitle>
                    <DialogContent style = {{ paddingLeft: '0px', paddingRight: '0px', marginLeft: '0px', marginRight: '0px', paddingTop: '0px' }}>  
                      <Paper square elevation={0}>
                        <Tabs
                         value={this.state.valueTab}
                         onChange={this.handleChangeTab}
                         variant="scrollable"
                          scrollButtons="auto"
                         >
                         <Tab label={TabLabel("General")} className={classes.tab} />
                         <Tab label={TabLabel("Financiero")} className={classes.tab} />
                         <Tab label={TabLabel("Estudiante")} className={classes.tab} />
                         <Tab label={TabLabel("Contable")} className={classes.tab} />
                        </Tabs>
                        <SwipeableViews
                            axis={classes.theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                            index={this.state.valueTab}
                            onTransitionEnd={this.onTransitionEnd}
                            onChangeIndex={this.handleChangeIndexTab}
                            containerStyle={{ transition: 'transform 0.35s cubic-bezier(0.15, 0.3, 0.25, 1) 0s' }}
                          >
                        <TabPanel value={this.state.valueTab} index={0} dir={classes.theme.direction}>
                          <TextField label="Código"
                                      variant="outlined"                                       
                                      inputProps={{ ref: this.codigoRef, maxLength: 10 }}                                     
                                      fullWidth
                                      defaultValue={this.codigo}
                                      required                                  
                                    />  
                            <TextField label="Descripción"
                                      variant="outlined"                                       
                                      inputProps={{ ref: this.descripcionRef, maxLength: 200 }}                                     
                                      fullWidth 
                                      className={classes.textField}    
                                      defaultValue={this.descripcion}     
                                      required                         
                                    />       
                            <Select Label='Tipo de transacción'
                                    Datos={this.state.datosSelectTT} 
                                    Selected= {this.state.selectedTT}
                                    onChange={this.handleChangeSelect} 
                                    Style={classes.formControlSelect}
                                    Outlined                                 
                                    Ref={this.ttRef}
                                    shrink={this.state.selectedTT !== '' ? true : undefined}
                                    required
                                    name="TT"
                                  />                     
                            <Select Label='Obligatoria'
                                    Datos={this.state.datosSelectOpciones} 
                                    Selected={this.state.selectedObligatoria}
                                    onChange={this.handleChangeSelect} 
                                    Style={classes.formControlSelect}
                                    Outlined                                 
                                    Ref={this.obligatoriaRef}
                                    shrink={this.state.selectedObligatoria !== '' ? true : undefined} 
                                    required
                                    name="Obligatoria" 
                                  />
                            <Select Label='Sucursal'
                                    Datos={this.state.datosSelectSucursal} 
                                    Selected={this.state.selectedSucursal}
                                    onChange={this.handleChangeSelect}
                                    Style={classes.formControlSelect}
                                    ShowItemNone
                                    Outlined                                 
                                    Ref={this.sucursalRef}
                                    shrink={this.state.selectedSucursal !== '' ? true : undefined} 
                                    LabelItemNone='(general)' 
                                    ValueItemNone={-1}
                                    name="Sucursal"
                                  />
                            <Select Label='Estado'
                                    Datos = {this.state.datosSelectEstado} 
                                    Selected= {this.state.selectedEstado}
                                    onChange={this.handleChangeSelect} 
                                    Style={classes.formControlSelect}
                                    Outlined                             
                                    Ref={this.estadoRef}
                                    shrink={this.state.selectedEstado !== '' ? true : undefined}  
                                    required
                                    name="Estado" 
                                  />
                        </TabPanel>
                        <TabPanel value={this.state.valueTab} index={1} dir={classes.theme.direction}>
                            <Select Label='Moneda'
                                    Datos={this.state.datosSelectMonedas} 
                                    Selected= {this.state.selectedMoneda}
                                    onChange={this.handleChangeSelect} 
                                    Style={classes.formControl}
                                    Outlined                                 
                                    Ref={this.monedaRef}
                                    shrink={this.state.selectedMoneda !== '' ? true : undefined}
                                    required
                                    name="Moneda"  
                                  />
                            <TextField label="Monto"
                                      variant="outlined"                                       
                                      inputProps={{ ref: this.montoRef, maxLength: 12, inputMode: movil ? 'decimal' : undefined }}                                     
                                      fullWidth 
                                      className={classes.textField} 
                                      defaultValue={this.monto} 
                                      onKeyDown={funciones.onlyNumbers(this.montoRef, false, true, true)} 
                                      onBlur={this.onBlurMonto}  
                                      required                              
                                    />
                            <Select Label='Financiado'
                                    Datos={this.state.datosSelectOpciones} 
                                    Selected= {this.state.selectedFinanciado}
                                    onChange={this.handleChangeSelect} 
                                    Style={classes.formControlSelect}
                                    Outlined                              
                                    shrink={this.state.selectedFinanciado !== '' ? true : undefined}
                                    name="Financiado"
                                  />
                            <Select Label='Trámite único'
                                    Datos = {this.state.datosSelectOpciones} 
                                    Selected= {this.state.selectedTU}
                                    onChange={this.handleChangeSelect} 
                                    Style = {classes.formControlSelect}
                                    Outlined                                  
                                    shrink={this.state.selectedTU !== '' ? true : undefined}
                                    name="TU"
                                  />
                        </TabPanel>
                        <TabPanel value={this.state.valueTab} index={2} dir={classes.theme.direction}>
                            <Select Label='Primer ingreso'
                                    Datos = {this.state.datosSelectOpciones} 
                                    Selected= {this.state.selectedPI}
                                    onChange={this.handleChangeSelect}
                                    Style={classes.formControl}
                                    Outlined                                  
                                    Ref = {this.piRef}
                                    shrink={this.state.selectedPI !== '' ? true : undefined}
                                    name="PI" 
                                  />                           
                              <Select Label='Becados'
                                    Datos = {this.state.datosSelectOpciones} 
                                    Selected= {this.state.selectedBecados}
                                    onChange={this.handleChangeSelect} 
                                    Style={classes.formControlSelect}
                                    Outlined
                                    shrink={this.state.selectedBecados !== '' ? true : undefined}
                                    name="Becados"
                                  />
                              <Select Label='Publicar'
                                    Datos = {this.state.datosSelectOpciones} 
                                    Selected= {this.state.selectedPublicar}
                                    onChange={this.handleChangeSelect} 
                                    Style={classes.formControlSelect}
                                    Outlined
                                    shrink={this.state.selectedPublicar !== '' ? true : undefined}
                                    name="Publicar"  
                                  />
                        </TabPanel>
                        <TabPanel value={this.state.valueTab} index={3} dir={classes.theme.direction}>
                            <TextField label="Cuenta contable"
                                      variant="outlined"                                       
                                      inputProps={{ ref: this.ccRef, maxLength: 25 }}                                     
                                      fullWidth
                                      defaultValue={this.cc}                                  
                                    />
                        </TabPanel>
                        </SwipeableViews>
                        </Paper>
                       </DialogContent>
                       <DialogActions>
                         <BarraBotones botones={this.botones_agregar} />
                      </DialogActions>
                  </Dialog>

                  <Dialog open={this.state.openBackDrop ? false : this.state.openModalConfirm}
                          classes={{ paper: classes.paperConfirm }}>
                    <DialogTitle><Typography component='span' variant='subtitle2'>Gestión</Typography>
                     <IconButton className={classes.closeButton} onClick={this.handleCloseConfirm} size="small">
                      <CloseIcon fontSize="small"/>
                     </IconButton>
                  </DialogTitle>
                    <DialogContent style={{ paddingTop: "20px", textAlign: "center" }}>
                      <Typography variant="body1" gutterBottom>
                        ¿Desea eliminar la gestión?
                      </Typography>        
                     </DialogContent>                   
                   <DialogActions style={{ marginTop: '20px'}}>
                     <BarraBotones botones={this.botones_eliminar} />
                   </DialogActions>
                  </Dialog>

                  <Backdrop className={classes.backdrop} open={this.state.openBackDrop}>                                       
                    <CircularProgress color="inherit" />
                    <span style={{ marginTop: '10px' }}>{this.state.actionModal === 3 ? 'Eliminando...' : 'Guardando...'}</span>
                  </Backdrop>
                  <Backdrop open={this.state.isLoadingMain} 
                            className={classes.backdrop} 
                            invisible 
                            transitionDuration={0}/>
                </React.Fragment>
              );

             }             
             
            })()

          }

          
        </Paper>
      </React.Fragment>
  );
  }
else if (this.state.isLoggin === false)
{
  //Auth.logout();
  window.location.reload();
  return; //((<Redirect to="/login"/>))
}
return null;

}//FIN RENDER
}

)